import { parseHTML as l } from "linkedom";
import { $generateHtmlFromNodes as i } from "@lexical/html";
import { createHeadlessEditor as a } from "@lexical/headless";
import { t as d, n as c } from "./index-Dlf9SKwk.js";
const w = ({ namespace: o }) => a({
  namespace: o,
  nodes: [...c],
  theme: d,
  onError: (e) => {
    console.error(e);
  }
});
function m() {
  const { window: o, document: e } = l("<html><body></body></html>");
  if (globalThis.window)
    return () => {
    };
  const n = globalThis.window, t = globalThis.document;
  return globalThis.window = o, globalThis.document = e, () => {
    globalThis.window = n, globalThis.document = t;
  };
}
function u() {
  if (globalThis && globalThis.window)
    return () => {
    };
  const o = globalThis.window;
  return globalThis.window = global, () => {
    globalThis.window = o;
  };
}
async function T(o) {
  return await new Promise((e) => {
    const n = u(), t = w({ namespace: "html-renderer" });
    t.setEditorState(t.parseEditorState(o)), n(), t.update(() => {
      try {
        const r = m(), s = i(t, null);
        r(), e(s);
      } catch (r) {
        console.log(r);
      }
    });
  });
}
export {
  T as getHtml
};
//# sourceMappingURL=server.es.js.map
